import { useEffect, useRef, useState } from "react";
import { heroStories, newsTicker } from "@/mocks/media";

export default function Hero() {
  const [active, setActive] = useState(0);
  const timer = useRef<number | null>(null);

  useEffect(() => {
    timer.current = window.setInterval(() => {
      setActive((a) => (a + 1) % heroStories.length);
    }, 6000);
    return () => {
      if (timer.current) window.clearInterval(timer.current);
    };
  }, []);

  const story = heroStories[active];

  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-10 pb-12 md:pt-14 md:pb-16 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            今日吃瓜 · 持续更新
          </div>
          <h1 className="mt-6 font-heading font-bold text-3xl md:text-[44px] leading-tight text-foreground-950">
            51影院 · 台前幕后的
            <span className="text-primary-600">真实模样</span>
          </h1>
          <p className="mt-5 text-foreground-600 leading-relaxed md:text-lg max-w-xl">
            演员情史、剧组内幕、明星片酬、替身演员与职业素养……娱乐圈的真真假假，我们用克制求真的方式，为你一一拆解。吃瓜不吃亏，看热闹更看门道。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-600 text-background-50 text-sm font-semibold hover:bg-primary-700 whitespace-nowrap"
            >
              <i className="ri-fire-line text-base"></i> 逛逛今日热榜
            </a>
            <a
              href="#yanshi"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-100 text-foreground-800 text-sm font-semibold hover:bg-background-200 whitespace-nowrap"
            >
              看看吃瓜栏目 <i className="ri-arrow-right-line text-base"></i>
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-3 gap-4 max-w-md">
            <div>
              <dt className="sr-only">栏目</dt>
              <dd className="font-heading text-2xl font-bold text-foreground-950">6<span className="text-primary-500 text-lg">大</span></dd>
              <dd className="text-xs text-foreground-500 mt-1">吃瓜栏目</dd>
            </div>
            <div>
              <dt className="sr-only">更新</dt>
              <dd className="font-heading text-2xl font-bold text-foreground-950">日更</dd>
              <dd className="text-xs text-foreground-500 mt-1">滚动跟进</dd>
            </div>
            <div>
              <dt className="sr-only">原则</dt>
              <dd className="font-heading text-2xl font-bold text-foreground-950">求真</dd>
              <dd className="text-xs text-foreground-500 mt-1">克制报道</dd>
            </div>
          </dl>
        </div>

        <div className="lg:col-span-7">
          <div className="relative rounded-2xl overflow-hidden bg-foreground-100">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                key={story.id}
                src={story.img}
                alt={story.title}
                title={`${story.title}-51影院`}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>
            <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
              {story.tag}
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <h2 className="font-heading font-bold text-lg md:text-2xl text-background-50 leading-snug">
                {story.title}
              </h2>
              <p className="mt-2 text-sm text-background-100/80 line-clamp-2 max-w-2xl hidden sm:block">
                {story.lead}
              </p>
            </div>
          </div>

          <div className="mt-4 flex items-center justify-between gap-3">
            <div className="flex gap-2">
              {heroStories.map((s, i) => (
                <button
                  key={s.id}
                  type="button"
                  onClick={() => setActive(i)}
                  aria-label={`切换到：${s.title}`}
                  className={`h-1.5 rounded-full transition-all ${i === active ? "w-8 bg-primary-600" : "w-4 bg-background-300 hover:bg-background-400"}`}
                ></button>
              ))}
            </div>
            <p className="text-xs text-foreground-400">{active + 1} / {heroStories.length}</p>
          </div>
        </div>
      </div>

      <div className="border-y border-background-200 bg-background-100 overflow-hidden">
        <div className="mx-auto max-w-7xl px-4 md:px-6 flex items-center gap-4 h-11">
          <span className="flex items-center gap-1.5 text-primary-600 text-xs font-bold whitespace-nowrap shrink-0">
            <i className="ri-flashlight-line text-sm"></i> 快讯
          </span>
          <div className="relative overflow-hidden flex-1 h-full flex items-center">
            <div className="flex gap-10 whitespace-nowrap animate-ticker">
              {[...newsTicker, ...newsTicker].map((n, i) => (
                <span key={i} className="text-sm text-foreground-600 inline-flex items-center gap-2">
                  <i className="ri-record-circle-line text-[8px] text-accent-600"></i>
                  {n}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}